import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {MonkeysGoldRowLockView} from "./MonkeysGoldRowLockView";
import {MonkeysGoldParsedGameData} from "../../server/data/MonkeysGoldParsedGameData";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {MonkeysGoldParsedInitData} from "../../server/data/MonkeysGoldParsedInitData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

/**
 * Created by Jerker Nord on 2020-06-02.
 */

export class MonkeysGoldRowLockController extends ReelStopPresentationController {

    private _lockView:MonkeysGoldRowLockView;
    private _previousNumberOfUpgrades:number;
    private _numberOfUpgrades:number = 0;
    private _cleanUp:boolean = false;

    constructor(index:number) {
        super(index, "MonkeysGoldRowLockController");
        this._lockView = MonkeysGoldGameModuleConfig.monkeysGoldRowLockView = new MonkeysGoldRowLockView();
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onInitDataParsed(data:MonkeysGoldParsedInitData):void {
        if(data.isRestoreState == true) {
            if(data.numberFilledRows > 0) {
                if(data.mode == GameMode.FREESPIN_AVALANCHE && data.nextMode == GameMode.FREESPIN) {
                    return;
                }
                MonkeysGoldGameModuleConfig.monkeysGoldRowLockWPController.setLockedRows(data.numberFilledRows);
                this._lockView.doRestore(data.numberFilledRows);
            }
        }
    }

    protected parseFeatureGameData(data:MonkeysGoldParsedGameData):void {
        this._previousNumberOfUpgrades = this._numberOfUpgrades;
        this._numberOfUpgrades = data.numberOfUpgrades;
        if(data.mode == GameMode.NORMAL_AVALANCHE) {
            if(data.avalancheCountThisSpinAfter > 0 && (data.avalancheCountThisSpinAfter == data.avalancheCountThisSpinBefore)) {
                this._cleanUp = true;
            }
        }
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(data.reelId == 5) {
            if(this._cleanUp == true) {
                this.cleanUp();
            }
            this.dispatchCompleteEvent(data.reelId);
        } else {
            this.dispatchCompleteEvent(data.reelId);
        }
    }

    private cleanUp():void {
        this._cleanUp = false;
        MonkeysGoldGameModuleConfig.monkeysGoldRowLockWPController.cleanUp();
        this._lockView.resetAllAnimations();
    }
}